import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';
import { getPersonalizedSearchPageRoute } from 'site-modules/shared/utils/personalized-search/personalized-search-utils';
import { ExperimentUtil } from 'client/utils/experiment/experiment-util';

export const routes = [
  {
    path: getPersonalizedSearchPageRoute(),
    exact: true,
    // eslint-disable-next-line no-empty-pattern
    page: getLoadablePage(({}, store) => {
      const state = store?.getState();
      const isSearch240Recipe = ExperimentUtil.getForcedOrAssignedRecipeName({
        state,
        campaignName: 'search-240-ui',
        defaultVal: 'ctrl',
      });
      const isSearch240Enabled = ['chal1', 'chal2'].includes(isSearch240Recipe);

      if (isSearch240Enabled && isSearch240Recipe === 'chal1') {
        return import(
          /* webpackChunkName: "personalized_search-search-240-chal1" */ '../pages/personalized-search-definition-search-240-chal1'
        );
      }

      if (isSearch240Enabled && isSearch240Recipe === 'chal2') {
        return import(
          /* webpackChunkName: "personalized_search-search-240-chal2" */ '../pages/personalized-search-definition-search-240-chal2'
        );
      }
      return import(/* webpackChunkName: "personalized_search" */ '../pages/personalized-search-definition');
    }),
    chunkName: 'personalized_search',
  },
];
